// extracted by mini-css-extract-plugin
export var inline = "_uu-0";